import React from 'react';
import PropTypes from 'prop-types';
import { createSkeletonItem } from '../Skeleton/SkeletonHelpers';
import '../Skeleton/Skeleton.scss';

const CommunityLogoWithLink = ({ className, communityData }) => {
  // Determine the content based on whether we have data
  const content = !communityData
    ? createSkeletonItem('div', `${className}__logoImg`, null, true)
    : (
      <img
        className={`${className}__logoImg`}
        src={communityData.logoUrl}
        alt={communityData.website}
      />
    );

  // Render with link if website exists and we have data
  if (communityData?.website) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={communityData.website}
        className={className}
      >
        {content}
      </a>
    );
  }

  // Render without link (for skeleton or no website)
  return (
    <div className={className}>
      {content}
    </div>
  );
};

CommunityLogoWithLink.propTypes = {
  className: PropTypes.string,
  communityData: PropTypes.shape({
    logoUrl: PropTypes.string,
    website: PropTypes.string,
  }),
};

CommunityLogoWithLink.defaultProps = {
  className: '',
  communityData: null,
};

export default CommunityLogoWithLink;
